import React from 'react';
import { theme } from 'antd';

interface AnnotationToolButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  disabled?: boolean;
}

const AnnotationToolButton: React.FC<AnnotationToolButtonProps> = ({ label, isActive, onClick, icon, disabled = false }) => {
  const { token } = theme.useToken();

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      title={label}
      disabled={disabled}
      className={`group flex flex-col items-center justify-center border-0 bg-transparent p-0 transition-all duration-200 ${
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer active:scale-95'
      }`}>
      <div
        className={`relative flex h-[34px] w-[34px] items-center justify-center rounded-full border transition-all duration-200 ${
          isActive
            ? 'scale-110'
            : 'scale-100 border-white/80 bg-white shadow-[0_6px_16px_rgba(0,0,0,0.12)] group-hover:-translate-y-0.5 group-hover:shadow-[0_10px_20px_rgba(0,0,0,0.16)]'
        }`}
        style={
          isActive
            ? {
                borderColor: token.colorPrimary,
                backgroundColor: `${token.colorPrimary}1A`,
                boxShadow: `0 0 0 4px ${token.colorPrimary}33`,
              }
            : undefined
        }>
        {icon}
        <div
          className={`pointer-events-none absolute inset-[-4px] rounded-full border transition-all duration-200 ${
            isActive ? '' : 'border-white/30'
          }`}
          style={isActive ? { borderColor: `${token.colorPrimary}4D` } : undefined}
        />
      </div>
    </button>
  );
};

export default AnnotationToolButton;
